import { v4 as uuidv4 } from 'uuid';

import {
  createBorrowerShell,
  createCapitalProviderRepresentativeShell,
  createCapitalProviderShell,
  createCreditAgreementShell,
} from '@finley-technologies/credit-agreement-utils';

import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

// TODO: pass artifactDocumentId
// and baseFields from the artifact
export const createCreditAgreementFullArtifactWipShell = (
  creditFacilityId: string,
): CreditAgreement.DomainEntity.CreditAgreementFullArtifact => {
  const creditAgreement = createCreditAgreementShell(
    creditFacilityId,
  ) as CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  const parties = creditAgreement.facilityMechanics.parties;
  parties.borrowers.push(createBorrowerShell(uuidv4()));
  parties.capitalProviders.push(createCapitalProviderShell(uuidv4()));
  parties.capitalProviderRepresentatives.push(
    createCapitalProviderRepresentativeShell(uuidv4()),
  );
  return creditAgreement;
};
